import { VideoModel } from '@_types/organisms';
import Icon from '@atoms/icons/Icon';
import getVideoSrc from '@helpers/getVideoSrc';
import SiteLoading from '@atoms/site-loading/SiteLoading';

type Props = Pick<VideoModel, 'videoId' | 'source'>;

const VideoOverlay = (model: Props) => {
  const { videoId, source } = model;

  const videoSrc = getVideoSrc(videoId, source);

  return (
    <div aria-modal="true" className="kf-o-video-overlay" data-source={source} data-video-id={videoId} role="dialog">
      <div className="kf-o-video-overlay__video">
        <div className="kf-o-video-overlay__close-icon" role="button" tabIndex={0}>
          <Icon iconPath="#kf-close" viewBoxHeight={24} viewBoxWidth={24} />
        </div>

        <iframe
          {...(videoSrc ? { src: videoSrc } : {})}
          allowFullScreen
          allow="autoplay; encrypted-media"
          referrerPolicy="strict-origin-when-cross-origin"
          title={'Video player'}
        />
      </div>

      <SiteLoading />
    </div>
  );
};

export default VideoOverlay;
